/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-24 19:05:13
 * @LastEditors: changfeng
 * @LastEditTime: 2024-03-25 11:50:23
 */
const Payment = () => {
	return <div className="PaymentDetailContainer{"></div>;
};

export default Payment;
